import React from "react";
import Typography from "@material-ui/core/Typography";
import { Box } from "@material-ui/core";
import EditOutlinedIcon from "@material-ui/icons/EditOutlined";

interface BoxRecapProps {
  titre: string;
  sousTitre1?: string;
  sousTitre2?: string;
  handleClick?: () => void;
  isEditable: boolean;
}
export const BoxRecap = ({
  titre,
  sousTitre1,
  sousTitre2,
  handleClick,
  isEditable,
}: BoxRecapProps) => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        padding: "10px",
        textAlign: "center",
        border: "1px solid #4E5BA6",
        borderRadius: "10px",
        backgroundColor: "#EEF6FB",
        width: "350px",
      }}
    >
      <Box>
        <Typography style={{ fontWeight: "bold" }}>{titre}</Typography>
        <Typography>
          <span>{sousTitre1 || "-"}</span>
        </Typography>
        <Typography>
          <span>{sousTitre2}</span>
          {isEditable && (
            <span
              onClick={handleClick}
              style={{
                padding: 10,
                cursor: "pointer",
                marginLeft: "10px",
                position: "relative",
                top: "7px",
              }}
            >
              <EditOutlinedIcon />
            </span>
          )}
        </Typography>
      </Box>
    </div>
  );
};
